import React from 'react';
import PropTypes from 'prop-types';

/**
 * THIRDPARTY IMPORTS
 */
import { Link } from 'react-router-dom';
import { Row, Col, Button, Menu, Icon, Layout, message } from 'antd';

import DivFlexCol from './../../styled/DivFlexCol';

import { removeAuthToken } from './../../utils/Helper';

import ApiService from './../../utils/ApiService';
import i18n from './../../utils/i18n';

const { Sider } = Layout;
const SubMenu = Menu.SubMenu;

export default class Navigation extends React.PureComponent {
  static propTypes = {
    /**
     * location Object from react-router-dom Router instance
     * @param string hash
     * @param string key
     * @param string pathname
     * @param string search
     * @param object || undefined state
     */
    location: PropTypes.object.isRequired,
    navData: PropTypes.array
  };

  handleLogout = () => {
    ApiService.user_accounts()
      .logout()
      .then(resp => {
        removeAuthToken();
        window.location = '/';
        message.success('Sie sind nun abgemeldet.');
      });
  };

  render() {
    const { location, navData } = this.props;

    // get the selected item from main nav via the pathname
    const selectedMainNav = navData.filter(item => {
      return location.pathname.indexOf(item.name) !== -1;
    });
    if (!selectedMainNav.length) return null;

    let openKeys = [];
    // create a jsx array with all sub nav items, including the divider
    let menuItems = [];
    selectedMainNav[0].sub.map((sub, i) => {
      if (i > 0) {
        menuItems = [...menuItems, <Menu.Divider key={i} />];
      }
      sub.map((subItem, index) => {
        const itemKey = `/${selectedMainNav[0].name}/${subItem.name}`;
        const isActive = location.pathname.includes(itemKey);
        const parentKey = `${i}${index}_${itemKey}`;
        const item =
          subItem.sub.length > 0 ? (
            <SubMenu key={parentKey} title={<span>{subItem.title}</span>}>
              {subItem.sub.map((subSub, subSubIndex) => {
                const subItemKey = `/${selectedMainNav[0].name}/${subSub.name}`;
                const subIsActive = location.pathname.includes('crud/')
                  ? location.pathname.split('/')[3]
                    ? location.pathname.split('/').length > 2
                      ? location.pathname.split('/')[3].toLowerCase() ===
                        subItemKey.split('/')[2].toLowerCase()
                      : false
                    : location.pathname.split('/')[2].toLowerCase() ===
                      subItemKey.split('/')[2].toLowerCase()
                  : false;
                if (subIsActive) {
                  openKeys = [...openKeys, parentKey];
                }
                return (
                  <Menu.Item
                    key={`${i}${index}_${subItemKey}`}
                    className={subIsActive ? 'ant-menu-item-selected' : ''}
                  >
                    <Link
                      to={`${subItemKey}${
                        subSub.target_url.includes('?')
                          ? '?' + subSub.target_url.split('?')[1]
                          : ''
                      }`}
                      aria-label={subSub.title}
                    >
                      <Icon type="right" />
                      {subSub.title}
                    </Link>
                  </Menu.Item>
                );
              })}
            </SubMenu>
          ) : (
            <Menu.Item
              key={`${i}${index}_${itemKey}`}
              className={isActive ? 'ant-menu-item-selected' : ''}
            >
              <Link to={itemKey} aria-label={subItem.title}>
                <Icon type="right" />
                {subItem.title}
              </Link>
            </Menu.Item>
          );
        menuItems = [...menuItems, item];
        return true;
      });
      return true;
    });

    return (
      <Sider width={256}>
        <DivFlexCol style={{ height: '100%' }} justify="space-between">
          <Row>
            <Menu
              style={{ width: 256 }}
              defaultSelectedKeys={[]}
              defaultOpenKeys={openKeys}
              selectedKeys={[]}
              mode="inline"
              theme="dark"
            >
              {menuItems}
            </Menu>
          </Row>
          <Row>
            <Col>
              <Button
                ghost={true}
                size="small"
                aria-label={i18n.actions.signOut}
                style={{ margin: 15 }}
                onClick={this.handleLogout}
              >
                {i18n.actions.signOut}
              </Button>
            </Col>
          </Row>
        </DivFlexCol>
      </Sider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js